export default __webpack_public_path__ + "static/media/Neophyte's Leggings of the Mandate.edfa7ee1.jpg";